(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["availability-notification-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const forms = document.querySelectorAll('[data-availability-form]');
    
    forms.forEach(form => {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const email = formData.get('email');
        const productId = formData.get('product_id');
        const productTitle = formData.get('product_title');
        
        const button = form.querySelector('.availability-notification__button');
        const successMessage = form.closest('.availability-notification').querySelector('[data-success-message]');
        
        button.disabled = true;
        button.style.opacity = '0.6';
        
        try {
          const response = await fetch('/apps/availability-notification', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: email,
              product_id: productId,
              product_title: productTitle
            })
          });
          
          if (response.ok) {
            form.style.display = 'none';
            successMessage.style.display = 'flex';
            
            setTimeout(() => {
              form.style.display = 'flex';
              successMessage.style.display = 'none';
              form.reset();
            }, 5000);
          } else {
            throw new Error('Erreur lors de l\'envoi');
          }
        } catch (error) {
          console.error('Erreur lors de l\'envoi:', error);
          alert('Une erreur est survenue. Veuillez réessayer.');
        } finally {
          button.disabled = false;
          button.style.opacity = '1';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
